import React, { useEffect, useState, useRef } from 'react';
import { reportsDialogCss } from './ReportsDialogCss';
import { withRouter, useHistory } from 'react-router-dom';
import {
    DialogTitle, DialogContent, DialogActions, Dialog
} from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '../ImageIcon';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import FilterComponent from '../FilterComponent/FilterComponent';
import TripStatusFilter from '../FilterComponent/TripStatusFIlter';
import DateFilter from '../FilterComponent/DateFilter';
import CustomDateFilterDialog from '../FilterComponent/CustomDateFilter';
import PartySupplierFilter from '../FilterComponent/PartySupplierFilter';
import DocumentBookPdfFilter from '../FilterComponent/DocumentBookPdfFilter';
import * as logger from "../../../logger";
import { getAllPnlMonths, getPNLPerMonth, getAllParties, getSinglePartyPDFReport, getAllVendors, getSingleVendorPDFReport } from '../../../store/actions/homeActionCreator';
import { vehicleTripPNLMonthlyList, vehicleTripPNLMonthlyPDF, getVehicleDocumentPDF, vehicleMonthlyPnlReportPDF, vehcileMonthlyPnlReportV2, vehcileMonthlyPnlReportPdf, truckIncomeExcel, getSingleDriverKhatPdf } from '../../../store/actions/vehicleActionCreator';
import { getTripPdf, getInvoicePdf } from '../../../store/actions/tripActionCreator';
import { profitLossPdfV2,partyPassbookReport,partyPassbookReportDownload,supplierPassbookReport,supplierPassbookReportDownload, downloadProfitLossPdfV2, pnlReportExcel, supplierLegerPdfV2, supplierLegerPdfDownloadV2, partyLegerPdfV2, partyLegerPdfDownloadV2, partyBalanceExcel, supplierBalanceExcel, getSingleShopKhataPdf, updateChatView } from '../../../store/actions/userActionCreators';
import { getTripStartDateFilterValues, getRequestTimeInMillis, getDateFilterValueForMonthlyBalance, getEpochForSpecificMonth, getMilliDatePickerDateInStringDDMMMYYYY } from "../../../utils/utils";
import {
    TRIP_FILTER_STATUS,
    TRIP_FILTER_STATUS_MAPPING,
} from "../../../store/constants";
import { trackDwebEvent } from '../../analytics';
import { SizeMe } from 'react-sizeme';
import { ExcelIconBlack, PdfIconWhite } from '../../../components/icons';

const ReportsDialog = ({

    // Using this variable incase many default values need to be passed from components .
    defaultValueObject,
    // *********************

    open,
    user,
    trip,
    vehicle,
    location,
    pdfMonth,
    vehicleNumberValue,
    reportType,
    tripIdFromPartySummary,
    truckType,
    onClose,
    name,
    invoiceId,
    fromDocumentBook,
    doNotShowExcelButton,
    dispatchGetDocumentsPDF,
    vehicleIdValue,
    pdfFilterValue,
    defaultDocumentFilterValueName,
    defaultDocumentFilterValueType,
    dispatchTripBookPdf,
    dispatchGetPnlMonths,
    dispatchGetTripPnlMonths,
    dispatchGetAllParties,
    dispatchGetSinglePartyPDFReportAction,
    dispatchGetAllVendors,
    dispatchGetSingleVendorPDFReportAction,
    dispatchGetMonthlyProfitLossPDF,
    fromSinglePartyPage,
    partyIdFromSingleParty,
    monthDate,
    monthStartEpochValue,
    monthEndEpochValue,
    fromSingleSupplierPage,
    vendorIdFromSingleSupplier,
    dispatchGetTripPdf,
    dispatchGetTruckMonthlyPnlV2,
    dispatchVehcileMonthlyPnlReportPdf,
    dispatchGetTruckIncomeExcel,
    fromProfileReports,
    fromPartyIncomeReport,
    partyIdFromPartyIncomeReport,
    dispatchGetPnlPdf,
    dispatchProfiLossReportDownload,
    dispatchDownloadPnlExcel,
    dispatchGetSupplierLedgerPdf,
    dispatchSupplierLedgerPdfDownload,
    dispatchGetPartyLedgerPdf,
    dispatchPartyLedgerPdfDownload,
    dispatchPartyBalanceExcel,
    dispatchSupplierBalanceExcel,
    dispatchGetInvoicePdf,
    fromSingleDriverPage,
    driverIdFromSingleDriver,
    dispatchGetSingleDriverKhatPdf,
    shopIdFromSingleShop,
    fromSingleShopPage,
    dispatchGetSingleShopKhataPdf,
    dispatchGetPartyPassbookPdf,
    dispatchGetPartyPassbookPdfDownload,
    dispatchGetSupplierPassbookPdf,
    dispatchGetSupplierPassbookPdfDownload,
    dispatchChatView
}) => {

    // ************************************* State variables *************************************
    const focusPdf = React.createRef();
    const [dialogOpen, setDialogOpen] = useState(open);
    const [dateValue, setDateValue] = useState("");
    const [pdfWidth, setPdfWidth] = useState(document.body.clientWidth - 35);
    const [numPages, setNumPages] = useState(null);
    const [reportData, setReportData] = useState({});
    const [tripStatus, setTripStatus] = useState("ACTIVE");
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [customer, setCustomer] = useState([]);
    const [changeDataFlag, setChangeDataFlag] = useState(false);
    const [startDateRange, setStartDateRange] = useState({});
    const [showTripStatusFilter, setShowTripStatusFilter] = useState((fromSinglePartyPage || fromSingleSupplierPage) ? false : true);
    const [documentFilterKeyValue, setDocumentFilterKeyValue] = useState("");
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});
    const [docCount, setDocCount] = useState(1);
    // *****************************************************


    const title = location.state && location.state.pageTitle ? location.state.pageTitle : ""
    var dateFilterValues = getTripStartDateFilterValues();

    var pageTitleValue = location && location.state && location.state.pageTitle ? location.state.pageTitle : "";

    let singleTruck = vehicle.singleTruck ? vehicle.singleTruck : "";


    // *********************************************** Setting Default Values if required ***********************************************
    useEffect(() => {

        dispatchChatView(false)

        if (defaultValueObject && defaultValueObject.tripStatusFilter) {
            setTripStatus(defaultValueObject.tripStatusFilter);
        }

        if (defaultValueObject && defaultValueObject.dateFilterStatus) {
            setDateFilterValue(defaultValueObject.dateFilterStatus);
        }

        if (defaultValueObject && defaultValueObject.customDateRange) {
            setCustomFilterValue(defaultValueObject.customDateRange);
        }

    }, [defaultValueObject])
    //  *******************************************
    const fetchPartyPdf = (requestData)=>{
        dispatchGetPartyPassbookPdf(
            requestData,
            (data) => {
                if (fromSinglePartyPage) {
                    trackDwebEvent('Dweb Single Party PDF', {
                        party_id: Number(partyIdFromSingleParty),
                        party_name: title
                    })
                }
                setShowTripStatusFilter(true);
                if (data && data.status && data.status.code == 200) {
                    let response = data.response;
                    if(response.pdfId){
                        requestData.pdfId = response.pdfId;
                    }
                    dispatchGetPartyPassbookPdfDownload(requestData,(res)=>{
                        if (res && res.status && res.status.code == 200) {
                            logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                            setTripStatus(data.response && data.response.defaultFilterApplied ? "ACTIVE" : "ALL");
                            setReportData(res.response)
                        }
                    },()=>{

                    })
                }
            },
            () => {
                logger.log("Reports Dialog Dweb", "Get Single Party PDF Failed");
                setShowTripStatusFilter(true);
                setTripStatus("ACTIVE");
            }
        )
    }

    const fetchSupplierPdf = (requestData)=>{
        dispatchGetSupplierPassbookPdf(
            requestData,
            (data) => {
                logger.log("Reports Dialog Component", "Get single vendor pdf successfull");
                if (vendorIdFromSingleSupplier) {
                    trackDwebEvent("Dweb Single Suppler PDF", {
                        "supplier_id": vendorIdFromSingleSupplier,
                        "supplier_name": pageTitleValue
                    })
                }
                setShowTripStatusFilter(true);
                if (data && data.status && data.status.code == 200) {
                    let response = data.response;
                    if(response.pdfId){
                        requestData.pdfId = response.pdfId;
                    }
                    dispatchGetSupplierPassbookPdfDownload(requestData,(res)=>{
                        if (res && res.status && res.status.code == 200) {
                            setTripStatus(data.response && data.response.defaultFilterApplied ? "ACTIVE" : "ALL");
                            setReportData(res.response)
                        }
                    },()=>{

                    })
                }
            },
            () => {
                logger.log("Reports Dialog Component", "Get single vendor pdf failed");
                setShowTripStatusFilter(true);
                setTripStatus("ALL");
            }
        )
    }


    // ************************************************ Calling initial APIs required for respective flows ************************************************
    useEffect(() => {
        if (name == "Export Party Passbook Report" || fromPartyIncomeReport) {
            let requestData = {
                customer: [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                //status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                defaultStatus: true
            }

            if (fromSinglePartyPage) {
                requestData.customerId = Number(partyIdFromSingleParty);
            }

            fetchPartyPdf(requestData)
        }else if (name == "Export Supplier Passbook Report") {

            let requestData = {
                vendors: [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                //status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                defaultStatus: true
            }

            if (fromSingleSupplierPage) {
                requestData.vendorId = Number(vendorIdFromSingleSupplier);
            }
            fetchSupplierPdf(requestData)
        }
        /*if (name == "Export Party Passbook Report" || fromPartyIncomeReport) {
            let requestData = {
                customer: [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                defaultStatus: true
            }

            if (fromSinglePartyPage) {
                requestData.customer = [Number(partyIdFromSingleParty)];
            }

            if (fromPartyIncomeReport) {
                requestData.customer = [Number(partyIdFromPartyIncomeReport)];
                if (pdfMonth) {
                    const filterValue = getEpochForSpecificMonth(pdfMonth);
                    requestData.startDateRange = filterValue
                }
            }

            dispatchGetAllParties({},
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Reports Dialog Dweb", "Get all Parties successfull");
                        dispatchGetSinglePartyPDFReportAction(
                            requestData,
                            (data) => {
                                if (fromSinglePartyPage) {
                                    trackDwebEvent('Dweb Single Party PDF', {
                                        party_id: Number(partyIdFromSingleParty),
                                        party_name: title
                                    })
                                }
                                if (fromProfileReports) {
                                    trackDwebEvent("Dweb Profile Party PDF", {});
                                }
                                setShowTripStatusFilter(true);
                                if (data && data.status && data.status.code == 200) {
                                    logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                                    setTripStatus(data.response && data.response.defaultFilterApplied ? "ACTIVE" : "ALL");
                                }
                            },
                            () => {
                                logger.log("Reports Dialog Dweb", "Get Single Party PDF Failed");
                                setShowTripStatusFilter(true);
                                setTripStatus("ACTIVE");
                            }
                        )

                    }
                },
                () => {
                    logger.log("Reports Dialog Dweb", "Get all Parties failed");
                }
            )
        } else

            if (name == "Export Supplier Passbook Report") {

                let requestData = {
                    vendors: [],
                    fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                    startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                    status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                    defaultStatus: true
                }

                if (fromSingleSupplierPage) {
                    requestData.vendors = [Number(vendorIdFromSingleSupplier)];
                }

                dispatchGetAllVendors({},
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Reports Dialog Component", "Get all Vendors Successfull");
                            dispatchGetSingleVendorPDFReportAction(
                                requestData,
                                (data) => {
                                    logger.log("Reports Dialog Component", "Get single vendor pdf successfull");
                                    if (vendorIdFromSingleSupplier) {
                                        trackDwebEvent("Dweb Single Suppler PDF", {
                                            "supplier_id": vendorIdFromSingleSupplier,
                                            "supplier_name": pageTitleValue
                                        })
                                    } else {
                                        trackDwebEvent("Dweb Profile Supplier PDF", {});
                                    }
                                    setShowTripStatusFilter(true);
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                                        setTripStatus(data.response && data.response.defaultFilterApplied ? "ACTIVE" : "ALL");
                                    }
                                },
                                () => {
                                    logger.log("Reports Dialog Component", "Get single vendor pdf failed");
                                    setShowTripStatusFilter(true);
                                    setTripStatus("ALL");
                                }
                            )
                        }
                    },
                    () => {
                        logger.log("Reports Dialog Component", "Get all Vendors Failed");
                    }
                );
            }*/

    }, [open]);
    // *********************************************************************


    // ****************************** Setting PDF APIs response into state variable ******************************
    useEffect(() => {

        if (focusPdf.current) {
            focusPdf.current.focus();
        }


    }, [focusPdf, open,reportData]);
    // *******************************************************************


    // ***************************************** Recalling respective PDF APIs when PDF filters change *****************************************
    useEffect(() => {

        if ((name == "Export Party Passbook Report" || fromPartyIncomeReport) && changeDataFlag) {
            let requestData = {
                customer: customer.length > 0 ? customer : [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus]
            }

            if (fromSinglePartyPage) {
                requestData.customerId = Number(partyIdFromSingleParty);
                requestData.defaultStatus = false
            }
            if (customFilterValue && customFilterValue.startTimeEpoch) {
                requestData.startDateRange = {
                    startTimeEpoch: customFilterValue.startTimeEpoch,
                    endTimeEpoch: customFilterValue.endTimeEpoch
                }
            }

            fetchPartyPdf(requestData)

        } else if (name == "Export Supplier Passbook Report" && changeDataFlag) {
            let requestData = {
                vendors: customer.length > 0 ? customer : [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
            }

            if (fromSingleSupplierPage) {
                requestData.vendorId = Number(vendorIdFromSingleSupplier);
                requestData.defaultStatus = false;
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                requestData.startDateRange = {
                    startTimeEpoch: customFilterValue.startTimeEpoch,
                    endTimeEpoch: customFilterValue.endTimeEpoch
                }
            }
            fetchSupplierPdf(requestData)
        }

    }, [dateValue, tripStatus, customer, dateFilterValue, startDateRange, documentFilterKeyValue, customFilterValue])
    // *****************************************


    // ***************************************** Assigning report dialog CSS to variable *****************************************
    const classes = reportsDialogCss();
    // *****************************************


    // **************************************** Triggered when report dialog closed ****************************************
    const handleClose = () => {
        dispatchChatView(true)
        setDialogOpen(false);
        onClose();
        setReportData({});
    }
    // *************************************************


    const handlePnlDate = (dateValueFromDateFilter) => {
        setDateValue(dateValueFromDateFilter);
        setChangeDataFlag(true);
    }

    // const handleDatePDFFilterClickOpen = () => {
    //     setPdfFilterOpen(true);
    // }

    const handleTripStatus = (value) => {
        setTripStatus(value);
        setChangeDataFlag(true);
    }

    const handleDateValue = (dateValue) => {
        if (dateValue == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setDateFilterValue(dateValue);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeDataFlag(true);
    }

    // pdf related settings
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        let header = document.getElementsByTagName('header')[0];
        if (header) {
            setPdfWidth(header.clientWidth - 60);
        }
        setNumPages(nextNumPages);
        // setNumPages(3);
    }

    const handleCheck = (value) => {
        setCustomer(value);
        setChangeDataFlag(true);
    }

    // Handling View Report from Single party monthly balance
    const handleMonthlyBalanceDate = (value) => {
        setDateValue(value);
        let dateValue = getDateFilterValueForMonthlyBalance(value);
        setStartDateRange(dateValue.startDateRange);
        setChangeDataFlag(true);

    }

    // ******************************************* Tracking Events when download button is clicked *******************************************
    const handleDownloadClick = () => {
        if (vendorIdFromSingleSupplier && name == "Export Supplier Passbook Report") {
            trackDwebEvent("Dweb Single Suppler PDF", {
                "supplier_id": vendorIdFromSingleSupplier,
                "supplier_name": pageTitleValue
            })
        } else if (name == "Export Party Passbook Report") {
            trackDwebEvent("Dweb Profile Party PDF Download", {});
        } else if (name == "Export Supplier Passbook Report") {
            trackDwebEvent("Dweb Profile Supplier PDF Download", {});
        }
    }
    // *******************************************


    const handleDocFilterSelect = (value) => {
        setDocumentFilterKeyValue(value);
        setChangeDataFlag(true);
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }


    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xl'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paperScrollPaper: classes.paper1, paperWidthXl: fromDocumentBook ? classes.paperWidth : "" }} >
                <DialogTitle id="add-party-dialog-title" onClose={handleClose} className={classes.dialogTitleV1}>
                    <span>
                        <span className={classes.fwV1}>{name == "Monthly Balance Tab" ? "Export Party Passbook Report" : name}</span>
                        {fromDocumentBook &&
                            <>
                                {vehicleNumberValue &&
                                    <span className={classes.vehicleNumber}> {vehicleNumberValue.vehicleNumberPrefix} < span className={classes.vehicleNumberSuffix}> {vehicleNumberValue.vehicleNumberSuffix}</span></span>
                                }
                                {truckType &&
                                    <>
                                        <span className={classes.bullet}>â€¢</span>
                                        <span className={classes.truckType}>{truckType}</span>
                                    </>
                                }
                            </>
                        }
                        {name == "Truck Monthly Profit and Loss Report" &&
                            <>
                                <span className={classes.mlV2}>
                                    {vehicleNumberValue && vehicleNumberValue.map((vehicleNumber) => (
                                        <span className={classes.vehicleNumberReport}> {vehicleNumber}</span>
                                    ))}
                                </span>
                            </>
                        }
                    </span>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={classes.dialogContentV1}>

                    {(name == "Export Party Passbook Report" || name == "Export Supplier Passbook Report") &&
                        <div className={classes.mtV1}>
                            <span className={classes.mlV1}>
                                <DateFilter dateValue={handleDateValue} fromReportsDialog={true} />
                            </span>
                        </div>
                    }
                    {reportData && reportData.s3Link ? (
                        <div className={classes.pdfContainer}>
                            <div className={classes.pdfSubContainer} tabIndex={0} ref={focusPdf} >
                                <SizeMe>
                                    {({ size }) => (
                                        <Document
                                            file={reportData && reportData.s3Link ? reportData.s3Link : null}
                                            onLoadSuccess={onDocumentLoadSuccess}
                                        >

                                            {/* <View style={styles.section}> */}
                                            {/* <Page pageNumber={pageNumber} width={pdfWidth} /> */}
                                            {
                                                Array.from(
                                                    new Array(numPages),
                                                    (el, index) => (
                                                        <Page
                                                            key={`page_${index + 1}`}
                                                            pageNumber={index + 1}
                                                            width={size.width ? size.width : 1}
                                                        />
                                                    ),
                                                )
                                            }
                                            {/* </View> */}

                                        </Document>
                                    )}
                                </SizeMe>
                            </div>
                        </div>
                    ) : (

                        <div className={classes.divV2}>
                            <ImageIcon />
                        </div>
                    )
                    }
                </DialogContent>
                {reportType != "excelReports" &&
                    <DialogActions className={classes.daV1}>
                        <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                            Close
                        </Button>
                        <a className={classes.anchorV1} href={reportData && reportData.s3Link ? reportData.s3Link : ""} target="_blank" download>
                            <Button className={classes.confirmV1} type="submit" variant="contained" onClick={() => handleDownloadClick()}>
                                Download
                            </Button>
                        </a>
                    </DialogActions>
                }
            </Dialog>

            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </>
    );

}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle, trip: state.trip });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetPnlMonths: (requestData, onSuccess, onFailure) => {
        dispatch(getAllPnlMonths(requestData, onSuccess, onFailure))
    },
    dispatchGetAllParties: (requestData, onSuccess, onFailure) => {
        dispatch(
            getAllParties(
                requestData, onSuccess, onFailure
            )
        )
    },
    dispatchGetSinglePartyPDFReportAction: (requestData, onSuccess, onFailure) => {
        dispatch(
            getSinglePartyPDFReport(
                requestData, onSuccess, onFailure
            )
        )
    },

    dispatchGetAllVendors: (requestData, onSuccess, onFailure) => {
        dispatch(
            getAllVendors(
                requestData, onSuccess, onFailure
            )
        )
    },
    dispatchGetSingleVendorPDFReportAction: (requestData, onSuccess, onFailure) =>
        dispatch(
            getSingleVendorPDFReport(
                requestData, onSuccess, onFailure
            )
        ),

    dispatchGetTripPnlMonths: (data, onSuccess, onFailure) => {
        dispatch(vehicleTripPNLMonthlyList(data, onSuccess, onFailure))
    },
    dispatchTripBookPdf: (data, onSuccess, onFailure) => {
        dispatch(vehicleTripPNLMonthlyPDF(data, onSuccess, onFailure))
    },
    dispatchGetDocumentsPDF: (data, onSuccess, onFailure) => { dispatch(getVehicleDocumentPDF(data, onSuccess, onFailure)) },
    dispatchGetMonthlyProfitLossPDF: (data, onSuccess, onFailure) => {
        dispatch(vehicleMonthlyPnlReportPDF(data, onSuccess, onFailure))
    },
    dispatchGetTripPdf: (tripId, onSuccess, onFailure) => {
        dispatch(getTripPdf(tripId, onSuccess, onFailure))
    },
    dispatchGetTruckMonthlyPnlV2: (vehicleId, filterData, onSuccess, onError) => {
        dispatch(vehcileMonthlyPnlReportV2(vehicleId, filterData, onSuccess, onError))
    },
    dispatchVehcileMonthlyPnlReportPdf: (vehicleId, pdfData, onSuccess, onError) => {
        dispatch(vehcileMonthlyPnlReportPdf(vehicleId, pdfData, onSuccess, onError))
    },
    dispatchGetTruckIncomeExcel: (filterData, onSuccess, onError) => {
        dispatch(truckIncomeExcel(filterData, onSuccess, onError))
    },
    dispatchGetPnlPdf: (filterData, onSuccess, onError) => {
        dispatch(profitLossPdfV2(filterData, onSuccess, onError))
    },
    dispatchProfiLossReportDownload: (pdfData, onSuccess, onError) => {
        dispatch(downloadProfitLossPdfV2(pdfData, onSuccess, onError))
    },
    dispatchDownloadPnlExcel: (monthYear, onSuccess, onError) => {
        dispatch(pnlReportExcel(monthYear, onSuccess, onError))
    },
    dispatchGetSupplierLedgerPdf: (requestData, onSuccess, onError) => {
        dispatch(supplierLegerPdfV2(requestData, onSuccess, onError))
    },
    dispatchSupplierLedgerPdfDownload: (pdfId, onSuccess, onError) => {
        dispatch(supplierLegerPdfDownloadV2(pdfId, onSuccess, onError))
    },
    dispatchGetPartyLedgerPdf: (requestData, onSuccess, onError) => {
        dispatch(partyLegerPdfV2(requestData, onSuccess, onError))
    },
    dispatchGetPartyPassbookPdf: (requestData, onSuccess, onError) => {
        dispatch(partyPassbookReport(requestData, onSuccess, onError))
    },
    dispatchGetPartyPassbookPdfDownload: (requestData, onSuccess, onError) => {
        dispatch(partyPassbookReportDownload(requestData, onSuccess, onError))
    },
    dispatchGetSupplierPassbookPdf: (requestData, onSuccess, onError) => {
        dispatch(supplierPassbookReport(requestData, onSuccess, onError))
    },
    dispatchGetSupplierPassbookPdfDownload: (requestData, onSuccess, onError) => {
        dispatch(supplierPassbookReportDownload(requestData, onSuccess, onError))
    },
    dispatchPartyLedgerPdfDownload: (pdfId, onSuccess, onError) => {
        dispatch(partyLegerPdfDownloadV2(pdfId, onSuccess, onError))
    },
    dispatchPartyBalanceExcel: (requestData, onSuccess, onError) => {
        dispatch(partyBalanceExcel(requestData, onSuccess, onError))
    },
    dispatchSupplierBalanceExcel: (requestData, onSuccess, onError) => {
        dispatch(supplierBalanceExcel(requestData, onSuccess, onError))
    },
    dispatchGetInvoicePdf: (invoiceId, onSuccess, onError) => {
        dispatch(getInvoicePdf(invoiceId, onSuccess, onError))
    },
    dispatchGetSingleDriverKhatPdf: (driverId, onSuccess, onError) => {
        dispatch(getSingleDriverKhatPdf(driverId, onSuccess, onError))
    },
    dispatchGetSingleShopKhataPdf: (shopId, onSuccess, onError) => {
        dispatch(getSingleShopKhataPdf(shopId, onSuccess, onError))
    },
    dispatchChatView: (value) => dispatch(updateChatView(value)),
});
const ReportsDialogWithRouter = withRouter(ReportsDialog);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportsDialogWithRouter);
